import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import useChangeEvent from "@dyl/hooks/useChangeEvent";
import evaluateWritingAutomarkerSentence from "@dyl/apiClients/backendApi/evaluateWritingAutomarkerSentence";
import DataGridDyl from "@dyl/components/DataGridDyl";

const Columns = [
    { headerName: 'Original Sentence', field: 'originalSentence', flex: 3 },
    { headerName: 'Corrected Sentence', field: 'correctedSentence', flex: 3 },
    { headerName: 'Perplexity Score', field: 'perplexityScore', flex: 1,
        valueFormatter({ value }) {
            return value.toFixed(2);
        }, },
    { headerName: 'Makes Sense', field: 'makesSense', flex: 1,
        valueFormatter({ value }) {
            return value ? 'True' : 'False';
        },
    },
]

export default function WritingAutomarkerAssess() {
    return (process.env.REACT_APP_ENVIRONMENT !== 'prod' && <WritingAutomarkerAssessInner />)
}

function WritingAutomarkerAssessInner() {

    const [sentence, setSentence] = useState('');
    const onSentenceChange = useChangeEvent(setSentence);
    const [data, setData] = useState([]);

    const evaluate = async() => {
        const result = await evaluateWritingAutomarkerSentence(sentence);
        result.id = data.length;
        setData([result].concat(data));
    };

    const onKeyUp = useCallback(async(event) => {
        if (event.code === 'Enter') { await evaluate(); }
    });

    return (
        <Grid container flex alignItems='flex-start' justifyContent='space-evenly' spacing={4}>

            <Grid item md={12}>
                <Typography variant='h6' noWrap >
                    A1 Writing Automarker - Sentence Score Assessment
                </Typography>
            </Grid>

            <Grid item md={8}>
                <TextField
                    label="Sentence"
                    variant="filled"
                    fullWidth
                    helperText={'The sentence to evaluate'}
                    onKeyUp={onKeyUp}
                    value={sentence}
                    onChange={onSentenceChange}
                />
            </Grid>

            <Grid item md={2}>
                <Button variant={'contained'}  onClick={evaluate} style={{ margin: '10px' }}>
                    Evaluate
                </Button>
            </Grid>

            <Grid item md={12}>
                <DataGridDyl
                    columns={Columns}
                    rows={data}
                />
            </Grid>
        </Grid>
    )
}